module.exports = __webpack_public_path__ + "static/media/glutem-free-2.e5c74994.jpg";